"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpResponse = void 0;
const http_status_enum_1 = require("./http-status.enum");
class HttpResponse {
    constructor(response = {}) {
        this.body = response.body;
        this.status = response.status;
        this.statusText = response.statusText;
        this.headers = response.headers;
    }
    get ok() {
        return [http_status_enum_1.HttpStatus.OK, http_status_enum_1.HttpStatus.CREATED].indexOf(this.status) >= 0;
    }
    get notFound() {
        return this.status === http_status_enum_1.HttpStatus.NOT_FOUND;
    }
    get unavailable() {
        return this.status === http_status_enum_1.HttpStatus.SERVICE_UNAVAILABLE;
    }
    get badRequest() {
        return this.status === http_status_enum_1.HttpStatus.BAD_REQUEST;
    }
    get forbidden() {
        return this.status === http_status_enum_1.HttpStatus.FORBIDDEN;
    }
    get unexpected() {
        return this.status === http_status_enum_1.HttpStatus.INTERNAL_SERVER_ERROR;
    }
    get unauthorized() {
        return this.status === http_status_enum_1.HttpStatus.UNAUTHORIZED;
    }
    get notAllowed() {
        return this.status === http_status_enum_1.HttpStatus.METHOD_NOT_ALLOWED;
    }
    get badGateway() {
        return this.status === http_status_enum_1.HttpStatus.BAD_GATEWAY;
    }
    get timeout() {
        return this.status === http_status_enum_1.HttpStatus.GATEWAY_TIMEOUT;
    }
}
exports.HttpResponse = HttpResponse;
//# sourceMappingURL=http-response.js.map